'use client';

import { isValidPostcode } from "@/lib/util";
import clsx from "clsx";
import { useTranslations } from "next-intl";

import styles from './FormPostcode.module.scss';

export enum ShowOptions {
	all = "All",
	patients = "Patients",
	passersby = "PassersBy"
}

export interface FormPostcodeProps {
	postcode?: string
	setPostcode: (postcode: string) => void
	show: ShowOptions

	setShow: (show: ShowOptions) => void

	displayMap: boolean
	setDisplayMap: (displayMap: boolean) => void
}

const FormPostcode = ({ postcode, setPostcode, show, setShow, displayMap, setDisplayMap }: FormPostcodeProps) => {
	const t = useTranslations();

	const handleShowChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
		setShow(e.target.value as ShowOptions);
	};

	const toggleMap = (e: React.MouseEvent<HTMLButtonElement>): void => {
		e.preventDefault();
		setDisplayMap(!displayMap);
	};

	return (
		<form className={styles.FormPostcode}
			onSubmit={(e) => {
				e.preventDefault();
				const formData = new FormData(e.currentTarget);
				const formPostcodeValue = formData.get('postcode') as string;
				if (isValidPostcode(formPostcodeValue)) {
					setPostcode(formPostcodeValue);
				}
			}}>
			<div className="flex-row" style={{ gap: '10px' }}>
				<div className="col-6">
					<label>{t("Generic.zoek-huisarts")}</label>
					<div className="flex-row" style={{ gap: '10px' }}>
						<input
							type="text"
							name="postcode"
							defaultValue={postcode}
							minLength={4}
							maxLength={7}
							required
							style={{ flexGrow: 1 }}
						/>
						<button type="submit" className="primary" style={{ flexGrow: 0 }}>{t('Generic.Zoek')}</button>
					</div>
				</div>
				<div className={clsx('col-6', styles.showLegend)}>
					<label>{t("Generic.Toon")}</label>
					<div className="flex-row" style={{ gap: '10px' }}>
						<select onChange={handleShowChange} defaultValue={show} style={{ flexGrow: 1 }}>
							<option value={ShowOptions.all}>{t("Generic.Alle")}</option>
							<option value={ShowOptions.patients}>{t("Generic.Legend.InschrijvenMogelijk")}</option>
							<option value={ShowOptions.passersby}>{t("Generic.Legend.PassantenWelkom")}</option>
						</select>

						<button onClick={toggleMap} style={{ flexGrow: 0, display: 'flex' }} className={displayMap ? 'primary' : ''}>
							{/* eslint-disable-next-line @next/next/no-img-element */}
							<img src="/icons/map.svg" alt={`icon`} />
							{t('Generic.Kaart')}
						</button>
					</div>
				</div>
			</div>
		</form>
	)
}
export default FormPostcode;
